var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-center align-center mb-6"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.fixWordpressUrl(_vm.filterValue(_vm.item.html)))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }